export const getSlotsLoading = state => state.slots.loading;
export const getGroupedSlotsByDate = state => state.slots.groupedSlotsByDate;
export const getNonWorkingDays = state => state.slots.nonWorkingDays;
